import React from 'react';
import HotelSearchBar from './HotelSearchBar';
import heroImg from '../Assets/Images/heroimg.jpg'; // replace with your actual image

const HeroSection = () => {
    return (
        <section>

            {/* --- Desktop / Tablet View --- */}
            <div
                className="d-none d-md-flex align-items-center justify-content-center text-center text-white"
                style={{
                    backgroundImage: `url(${heroImg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100vh',
                    position: 'relative',
                }}
            >
                {/* Overlay */}
                <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        zIndex: 1,
                    }}
                ></div>

                <div
                    className="container position-relative z-2"
                    style={{ maxWidth: '960px', padding: '0 1rem' }}
                >
                    <h1 className="fw-bold display-5 mb-3">
                        Discover Your Next Adventure with <span className="text-success">ZoyoTrip</span>
                    </h1>
                    <p className="lead mb-4">
                        Book Hotels, Cars & More — Wherever Your Journey Takes You
                    </p>
                    <div className="mt-4 hero-search">
                        <HotelSearchBar />
                    </div>
                </div>
            </div>

            {/* --- Mobile View --- */}
            <div 
                className="d-block d-md-none text-white text-start position-relative overflow-hidden"
                style={{
                    backgroundImage: `url(${heroImg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    padding: '2.5rem 1rem 3rem 1rem',
                }}
            >
                {/* Overlay */}
                <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.65)',
                        zIndex: 1,
                    }}
                ></div>

                <div className="position-relative z-2">
                    <h2 className="fw-bold mb-1" style={{ fontSize: '1.75rem', lineHeight: '1.2' }}>
                        Find your next <span className="text-success">stay</span>
                    </h2>
                    <p className="small text-white-50 mb-3">Book hotels & homestays at the best prices</p>
                    <HotelSearchBar />
                </div>
            </div>

        </section>
    );
};

export default HeroSection;
